<template>
  <div class="htrank">
    <div class="title">{{ ranktitle }}</div>
    <div class="dnrklist">
      <div
        v-for="(item, index) in 10"
        :key="index"
        @mouseover="rkactiv = index"
      >
        <div class="dnrkitem flex_start" v-if="index != rkactiv">
          <div class="sort" :class="{ sortqs: index < 3 }">{{ item }}</div>
          <div class="text ellipsis">房屋租赁合同范本大全</div>
        </div>
        <div class="dnrkitemact flex_start" v-if="index == rkactiv">
          <div class="cover">
            <img src="../../../assets/jpcol/htcover_sample.png" alt="" />
            <div class="sort" :class="{ sortqs: index < 3 }">{{ item }}</div>
          </div>
          <div class="text">
            <div>{{ `房屋租赁合同范本大全` | toEllipsisFilter(27) }}</div>
            <div class="num flex_start">
              <div class="pric">¥9.9</div>
              <div class="xd">2100人下单</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ranktitle: {
      type: String,
      default: "下载排行榜",
    },
  },
  data: () => ({
    rkactiv: 0,
  }),
};
</script>

<style lang="scss" scoped>
.htrank {
  width: 100%;
  height: 100%;
  padding: 26px 21px;
  .title {
    font-size: 24px;
    color: #333333;
  }
  .dnrklist {
    .dnrkitem {
      cursor: pointer;
      margin-top: 23px;
      .sort {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #f8f8f8;
        font-size: 16px;
        color: #9c9c9c;
        margin-right: 14px;
        &.sortqs {
          color: #ffffff;
          background: #e33e39;
        }
      }
      .text {
        width: 225px;
      }
    }
    .dnrkitemact {
      cursor: pointer;
      margin-top: 23px;
      align-items: flex-start;
      position: relative;
      .cover {
        position: relative;
        .sort {
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background: #f8f8f8;
          font-size: 16px;
          color: #9c9c9c;
          position: absolute;
          top: 1px;
          left: 0;
          &.sortqs {
            color: #ffffff;
            background: #e33e39;
          }
        }
        img {
          width: 82px;
          height: 102px;
        }
      }
      .text {
        margin-left: 10px;
        width: 165px;
        .num {
          position: absolute;
          bottom: 10px;
          .pric {
            font-size: 16px;
            color: #da0000;
          }
          .xd {
            margin-left: 32px;
            font-size: 12px;
            color: #969696;
          }
        }
      }
    }
  }
}
</style>